"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialMedia = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
class SocialMedia {
}
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    tslib_1.__metadata("design:type", String)
], SocialMedia.prototype, "weedmaps", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    tslib_1.__metadata("design:type", String)
], SocialMedia.prototype, "instagram", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    tslib_1.__metadata("design:type", String)
], SocialMedia.prototype, "facebook", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: "" }),
    tslib_1.__metadata("design:type", String)
], SocialMedia.prototype, "twitter", void 0);
exports.SocialMedia = SocialMedia;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic29jaWFsTWVkaWEuanMiLCJzb3VyY2VSb290IjoiLi9zcmMvIiwic291cmNlcyI6WyJwYWNrYWdlcy9tb2RlbHMvc3JjL3NvY2lhbE1lZGlhLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxxQ0FBaUM7QUFFakMsTUFBYSxXQUFXO0NBU3ZCO0FBUkc7SUFBQyxJQUFBLGdCQUFNLEVBQUMsRUFBRSxPQUFPLEVBQUUsRUFBRSxFQUFFLENBQUM7OzZDQUNQO0FBQ2pCO0lBQUMsSUFBQSxnQkFBTSxFQUFDLEVBQUUsT0FBTyxFQUFFLEVBQUUsRUFBRSxDQUFDOzs4Q0FDTjtBQUNsQjtJQUFDLElBQUEsZ0JBQU0sRUFBQyxFQUFFLE9BQU8sRUFBRSxFQUFFLEVBQUUsQ0FBQzs7NkNBQ1A7QUFDakI7SUFBQyxJQUFBLGdCQUFNLEVBQUMsRUFBRSxPQUFPLEVBQUUsRUFBRSxFQUFFLENBQUM7OzRDQUNSO0FBUnBCLGtDQVNDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgQ29sdW1uIH0gZnJvbSBcInR5cGVvcm1cIjtcblxuZXhwb3J0IGNsYXNzIFNvY2lhbE1lZGlhIHtcbiAgICBAQ29sdW1uKHsgZGVmYXVsdDogXCJcIiB9KVxuICAgIHdlZWRtYXBzOiBzdHJpbmc7XG4gICAgQENvbHVtbih7IGRlZmF1bHQ6IFwiXCIgfSlcbiAgICBpbnN0YWdyYW06IHN0cmluZztcbiAgICBAQ29sdW1uKHsgZGVmYXVsdDogXCJcIiB9KVxuICAgIGZhY2Vib29rOiBzdHJpbmc7XG4gICAgQENvbHVtbih7IGRlZmF1bHQ6IFwiXCIgfSlcbiAgICB0d2l0dGVyOiBzdHJpbmc7XG59XG4iXX0=